export class SchedulerRoutes
{
    static Home: string = "/";
    // scheduler
    static SchedulerList: string = "/scheduler/list";
    static SchedulerNew: string = "/scheduler/new";
    static SchedulerView(id: string)
    {
        return `/scheduler/${id}/view`;
    }
    static SchedulerEdit(id: string)
    {
        return `/scheduler/${id}/edit`;
    }
    static SchedulerCopy(id: string)
    {
        return `/scheduler/${id}/copy`;
    }
}